export const GET_COWORKER_LIST_REQUEST = 'get_coworker_list_request';
export const GET_COWORKER_LIST_SUCCESS = 'get_coworker_list_success';
export const GET_COWORKER_LIST_FAILURE = 'get_coworker_list_failure';
// export const GET_COWORKER_LIST_RESET = 'get_coworker_list_reset';